





























































































import { Component, Vue, Prop, Watch, Provide } from "vue-property-decorator";
import router from "@/router";
import axios from "axios";

import TaxabilityTable from "@/components/TaxabilityTable.vue";
import CompaniesSwitcher from "../components/CompaniesSwitcher.vue";

/* eslint-disable @typescript-eslint/camelcase */
interface TaxabilityRule {
  taxability: string;
  jurisdiction_name: string;
  jurisdiction_code: string;
  country_code: string;
  jurisdiction_type: string;
  additional_info: string;
}
/* eslint-enable @typescript-eslint/camelcase */

interface TaxabilityRules {
  taxcode: string;
  rules: TaxabilityRule[];
}

enum Region {
  US = "US",
  CA = "CA",
}

@Component({
  components: { TaxabilityTable, CompaniesSwitcher },
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name === "taxability_search") {
        vm.$store.state.backRoute = from;
      }
    });
  },
})
export default class TaxabilityAvatax extends Vue {
  @Provide("$api") $api: any;
  @Provide("$_") $_: any;
  @Prop({ default: "" }) private companyId!: string;

  private isTableLoading = false;
  private itemsUrl = "";

  Region = Region;

  taxabilities: TaxabilityRules[] = [];
  taxabilitySummary: {
    totalItems: number;
    iteratedItems: number;
    iteratedTaxCodes: number;
  } = { totalItems: 0, iteratedItems: 0, iteratedTaxCodes: 0 };
  codeToJurisdictionTaxability: {
    [taxCode: string]: { [jurisdiction: string]: TaxabilityRule };
  } = {};

  mounted() {
    this.loadItemsUrl();
    this.loadTaxability();
  }

  @Watch("companyId")
  public loadItemsUrl(): void {
    if ((window as any).itemsUrl) {
      this.itemsUrl = (window as any).itemsUrl
        .replace("{accountId}", this.$store.getters.accountID)
        .replace("{companyId}", this.companyId);
    }
  }

  get avataxTaxcodeMessage() {
    return `Below Taxability Matrix is generated only for the ${this.taxabilitySummary.iteratedTaxCodes} Avalara tax codes present in the first ${this.taxabilitySummary.iteratedItems} items out of total ${this.taxabilitySummary.totalItems} items in your AvaTax account. To see the taxability for other tax codes, use`;
  }

  @Watch("companyId")
  public loadTaxability(): void {
    this.$store.commit("startLoading");
    this.isTableLoading = true;
    this.$api
      .get(`/api/taxability/${this.companyId}/`, { validateStatus: false })
      .then((response) => {
        if (response.status === 200) {
          this.taxabilities = response.data.taxability;
          this.taxabilitySummary = response.data.taxCodesSummary;
          this.taxabilities.length === 0
            ? this.$store.commit("stopLoading")
            : this.updateCodeToJurisdictionTaxabilityMap();
        } else {
          this.taxabilities = [];
          this.$store.commit("stopLoading");
        }
        this.isTableLoading = false;
      })
      .catch((error) => this.$store.commit("stopLoading"));
  }

  public updateCodeToJurisdictionTaxabilityMap(): void {
    this.taxabilities.forEach((taxability: TaxabilityRules) => {
      const taxCode: string = taxability.taxcode;
      const jurisdictionsToTaxability: { [key: string]: TaxabilityRule } = {};
      taxability.rules.forEach((rule: TaxabilityRule) => {
        const jurisdiction: string = rule.jurisdiction_name;
        jurisdictionsToTaxability[jurisdiction] = rule;
      });
      this.codeToJurisdictionTaxability[taxCode] = jurisdictionsToTaxability;
    });
  }

  public getRegion() {
    if (this.taxabilities.length > 0 && this.taxabilities[0].rules.length > 0)
      return this.taxabilities[0].rules[0].country_code;
    return Region.US;
  }

  public getTaxCodes() {
    if (Object.keys(this.codeToJurisdictionTaxability).length > 0)
      return Object.keys(this.codeToJurisdictionTaxability);
    return [];
  }

  public getJurisdictions() {
    const allJurisdictions: string[] = this.taxabilities.flatMap(
      (taxability: TaxabilityRules) => {
        return taxability.rules.map((rule) => rule.jurisdiction_name);
      }
    );
    const allDistinctJurisdictions: string[] = Array.from(
      new Set(allJurisdictions)
    );
    return allDistinctJurisdictions;
  }

  companySwitched(event) {
    const params = Object.assign({}, this.$route.params, {
      companyId: event.companyId,
    });

    this.$router.push({ name: "taxability_avatax", params: params });
  }

  get back() {
    return this.$store.state.backRoute || {};
  }
}
